import React from "react"
import PropTypes from "prop-types"
import { Box, Paper } from "@mui/material"
import theme from "src/v2/theme/theme"
import { getMemoriaCalculoModalConfig } from "./../memoria-calculo-sections/configs/memoria-calculo-modal-config"
import {
    MemoriaCalculoFieldsSection,
    MemoriaCalculoTableSection,
} from "./../memoria-calculo-sections/memoria-calculo-sections"

const sectionPaperSx = {
    borderRadius: 0,
    p: 3,
    background: theme.palette.background.paper,
}

export const MemoriaCalculoPanel = ({
    parametersHeader,
    data,
    hasResultado,
    puparData,
    puMtmData,
    loadingSections,
}) => {
    const config = getMemoriaCalculoModalConfig({ data, hasResultado, puparData, puMtmData })

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                background: theme.palette.background.primary,
            }}
        >
            <Paper elevation={0} sx={sectionPaperSx}>
                {parametersHeader}

                <MemoriaCalculoFieldsSection
                    title={config.parametros.title}
                    sections={config.parametros.sections}
                    loading={loadingSections.parametros}
                />
            </Paper>

            <Paper elevation={0} sx={{ ...sectionPaperSx, mt: 3}}>
                <MemoriaCalculoTableSection
                    columns={config.resultado.sections[0].columns}
                    rows={config.resultado.sections[0].rows}
                    loading={loadingSections.resultado}
                />
            </Paper>
            <Paper elevation={0} sx={{ ...sectionPaperSx, mt: 3}}>
                <MemoriaCalculoTableSection
                    title={config.pupar.title}
                    columns={config.pupar.sections[0].columns}
                    rows={config.pupar.sections[0].rows}
                    loading={loadingSections.pupar}
                />
            </Paper>
            <Paper elevation={0} sx={{ ...sectionPaperSx, mt: 3}}>
                <MemoriaCalculoTableSection
                    title={config.pu_mtm.title}
                    columns={config.pu_mtm.sections[0].columns}
                    rows={config.pu_mtm.sections[0].rows}
                    loading={loadingSections.puMtm}
                />
            </Paper>
        </Box>
    )
}

MemoriaCalculoPanel.propTypes = {
    data: PropTypes.object,
    parametersHeader: PropTypes.node,
    hasResultado: PropTypes.bool,
    puparData: PropTypes.array,
    puMtmData: PropTypes.array,
    loadingSections: PropTypes.shape({
        parametros: PropTypes.bool,
        resultado: PropTypes.bool,
        pupar: PropTypes.bool,
        puMtm: PropTypes.bool,
    }),
}

MemoriaCalculoPanel.defaultProps = {
    hasResultado: false,
    puparData: [],
    puMtmData: [],
    loadingSections: {
        parametros: false,
        resultado: false,
        pupar: false,
        puMtm: false,
    },
}
